import Layout from "../../components/Layout/Layout";
import TransactionTable from "../../components/CDP/Subscription/TransactionTable";
import TransactionFilter from "../../components/CDP/Subscription/TransactionFilter";
import apiService from "../../apiService/Subscription/api-service";
import { useSubscriptionFilters } from "./hooks/useSubscriptionFilters";
import { buildSubscriptionFilterPayload, triggerFileDownload } from "./utils";

const DEFAULT_FILTERS = {
  searchBy: "date",
  productFilter: "",
  searchTerm: "",
  planFilter: "",
  platformFilter: "",
};

export default function Transactions() {
  const {
    filters,
    setFilters,
    appliedFilters,
    dateValue,
    isExporting,
    setIsExporting,
    handleApply,
    handleReset,
    handleDateSelect,
  } = useSubscriptionFilters(DEFAULT_FILTERS);

  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      const payload = buildSubscriptionFilterPayload(appliedFilters);
      const response = await apiService.exportTransactions({
        searchBy: payload.searchBy,
        start_date: dateValue?.startDate,
        end_date: dateValue?.endDate,
        product_id: payload.productFilter,
        plan: payload.planFilter,
        platform: payload.platformFilter,
        search: payload.searchTerm,
      });
      const data = response?.data?.data?.reportData || null;
      if (data?.downloadUrl) {
        triggerFileDownload(data.downloadUrl, data.fileName || "transactions.csv");
      } else {
        window.alert("No data for the selected filters!");
      }
    } catch (error) {
      window.alert("Unable to export transactions at this time. Please try again later.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-screen p-6">
        <div className="mx-auto max-w-7xl">
          <TransactionFilter
            onDateSelect={handleDateSelect}
            dateValue={dateValue}
            filters={filters}
            setFilters={setFilters}
            handleApply={handleApply}
            handleReset={handleReset}
            handleExport={handleExport}
          />
          <TransactionTable dateValue={dateValue} filtersdata={appliedFilters} />
        </div>
      </div>
    </Layout>
  );
}
